import { useQuery } from '@tanstack/react-query'
import {
  accessControlApi,
  type ListUsersQuery,
} from '../api/access-control.client'

export const USERS_QUERY_KEY = ['access-control', 'users'] as const

export function useUsersQuery(params?: ListUsersQuery) {
  return useQuery({
    queryKey: [...USERS_QUERY_KEY, params],
    queryFn: () => accessControlApi.listUsers(params),
    retry: false,
    refetchOnWindowFocus: false,
  })
}
